export const BASE_URL = "https://control.clickcoach.app/api/rest";
export const PAGE_LIMIT = 5;